var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IG ico MENU") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0489113924 27.951 0.0489113924 27.951 27.949362 0 27.949362"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Design-v10",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8-Footer",
    transform: "translate(-174.000000, -298.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social",
    transform: "translate(76.000000, 284.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IG",
    transform: "translate(84.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IG-ico-MENU",
    transform: "translate(14.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.001722)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1391101,19.6376658 C25.1391101,22.677919 22.669987,25.1425772 19.6242261,25.1425772 L8.32678406,25.1425772 C5.28102319,25.1425772 2.81184928,22.677919 2.81184928,19.6376658 L2.81184928,8.36060253 C2.81184928,5.32029873 5.28102319,2.85569114 8.32678406,2.85569114 L19.6242261,2.85569114 C22.669987,2.85569114 25.1391101,5.32029873 25.1391101,8.36060253 L25.1391101,19.6376658 Z M19.6242261,0.0489063291 L8.32678406,0.0489063291 C3.73534203,0.0489063291 -2.02898551e-05,3.77751392 -2.02898551e-05,8.36060253 L-2.02898551e-05,19.6376658 C-2.02898551e-05,24.2207544 3.73534203,27.949362 8.32678406,27.949362 L19.6242261,27.949362 C24.2156174,27.949362 27.9510304,24.2207544 27.9510304,19.6376658 L27.9510304,8.36060253 C27.9509797,3.77751392 24.2155667,0.0489063291 19.6242261,0.0489063291 L19.6242261,0.0489063291 Z",
    id: "Fill-1",
    fill: "#F1EDE4",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.9754797,18.4101063 C11.5358783,18.4101063 9.55822609,16.436081 9.55822609,14.0008405 C9.55822609,11.5656506 11.535929,9.59157468 13.9754797,9.59157468 C16.4151319,9.59157468 18.3927333,11.5656506 18.3927333,14.0008405 C18.3927333,16.4360304 16.4150812,18.4101063 13.9754797,18.4101063 M13.9754797,6.78478987 C9.98933478,6.78478987 6.74635652,10.0219038 6.74635652,14.0008405 C6.74635652,17.9796759 9.98933478,21.2168911 13.9754797,21.2168911 C17.9616246,21.2168911 21.2046536,17.9797266 21.2046536,14.0008405 C21.2046536,10.0219038 17.9616246,6.78478987 13.9754797,6.78478987",
    id: "Fill-4",
    fill: "#F1EDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2186029,5.10986835 C22.1753203,5.10986835 22.9508493,5.88404557 22.9508493,6.83898228 C22.9508493,7.79396962 22.1753203,8.5680962 21.2186029,8.5680962 C20.2619362,8.5680962 19.4864072,7.79396962 19.4864072,6.83898228 C19.4864072,5.88404557 20.2619362,5.10986835 21.2186029,5.10986835",
    id: "Fill-6",
    fill: "#F1EDE4"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsta);
export default __webpack_public_path__ + "static/media/icon_insta.83dfe9dab5f1f8811e4011d446a35fd5.svg";
export { ForwardRef as ReactComponent };